
import Keycloak from 'keycloak-js';
 
// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
console.log(process.env.REACT_APP_KEYCLOAK_URL)
console.log(process.env.REACT_APP_KEYCLOAK_CLIENT_ID)
const keycloakauth  = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});
export default keycloakauth